// Layer types (Layer types that can be enabled / disabled)
export const MAP_LAYER_TYPES = {
  assets: 'assets',
  basins: 'basins',
  blocks: 'blocks',
  ccusProjects: 'ccus_projects',
  co2Emitters: 'co2_emitters',
  countryBoundaries: 'country_boundaries', // Non country specific tileset layer (Added as additional layer)
  eaWells: 'eawells',
  facilities: 'facilities',
  fields: 'fields',
  formations: 'formations',
  leases: 'leases',
  lng: 'lng', // Non country specific tileset layer (Added as additional layer)
  pipelines: 'pipelines',
  pipelineNetworks: 'pipeline_networks', // Non country specific tileset layer (Added as additional layer)
  pipelineSegments: 'pipeline_segments',
  presaltPolygons: 'presalt_polygons',
  screening: 'screening', // Non country specific tileset layer (Added as additional layer)
  storageSites: 'storage_sites',
  wells: 'wells',
};
